import React from "react";

const Notification = () => {
  return <div className="primary">Notification</div>;
};

export default Notification;
